module.exports = __webpack_public_path__ + "img/google.69787ac0.svg";